import { createMemoStyles } from '@wds/utils';

import { PricingAppTheme } from '~app/styles/pricing/types';
import footerImg from '~pricing/components/PricingFooter/assets/pricing_footer.png';
import { XL_MEDIA_QUERY, LG_MEDIA_QUERY, MD_MEDIA_QUERY, SM_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ pricingPalette, spacing, type }: PricingAppTheme) => ({
  Footer: {
    padding: [0, spacing[6]],
    margin: [spacing[5], 'auto', spacing[6]],
    [XL_MEDIA_QUERY]: {
      margin: [spacing[5], spacing[10], spacing[6]],
    },
  },
  Header: {
    background: 'rgba(249,190,0,0.25);',
    padding: spacing[2],
    '& h1': {
      fontWeight: type.fontWeight.medium,
    },
  },
  Content: {
    background: pricingPalette.colors.white,
    '& p': {
      margin: [spacing[4], 0],
    },
  },
  Audience: {
    display: 'none',
    [SM_MEDIA_QUERY]: {
      display: 'block',
    },
  },
  Accordion: {
    display: 'block',
  },
  AccordionContent: {
    display: 'none',
  },
  FAQHeading: {
    padding: [spacing[3], 0, spacing[2]],
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
    '& h5': {
      fontWeight: 500,
    },
    [MD_MEDIA_QUERY]: {
      pointerEvents: 'none',
    },
  },
  Answer: {
    paddingBottom: spacing[2],
    '& a': {
      whiteSpace: 'nowrap',
      fontSize: 14,
    },
  },
  Spacer: {
    [SM_MEDIA_QUERY]: {
      display: 'none',
    },
    [MD_MEDIA_QUERY]: {
      display: 'block',
    },
  },
  Active: {
    '& $AccordionContent': {
      display: 'block',
    },
  },
  Inactive: {
    '& $AccordionContent': {
      display: 'none',
    },
    [MD_MEDIA_QUERY]: {
      '& $AccordionContent': {
        display: 'block',
      },
    },
  },
  Toggle: {
    [MD_MEDIA_QUERY]: {
      display: 'none',
    },
  },
  Features: {
    '& h2': {
      fontWeight: type.fontWeight.medium,
    },
    [LG_MEDIA_QUERY]: {
      background: `url(${footerImg}) no-repeat top left`,
      backgroundSize: 'contain',
      paddingTop: 0,
      paddingLeft: 300,
    },
  },
  FeatureList: {
    padding: 0,
  },
  Feature: {
    display: 'flex',
    fontSize: 14,
    margin: [0, spacing[3], spacing[4], spacing[4]],
    '& svg': {
      width: 18,
      height: 18,
      marginRight: 5,
      flex: '0 0 auto',
    },
    [MD_MEDIA_QUERY]: {
      display: 'inline-flex',
      alignItems: 'center',
      width: 'calc(50% - 32px)',
      maxWidth: 300,
    },
  },
  Disclaimers: {
    display: 'block',
    listStyle: 'none',
    padding: 0,
  },
  Disclaimer: {
    margin: [spacing[2], 0],
  },
  GetStarted: {
    fontSize: 18,
    marginBottom: spacing[5],
  },
  More: {
    borderTop: `1px solid ${pricingPalette.colors.pebble}`,
    margin: [15, 0, spacing[6]],
    paddingTop: 30,
    '&>h4': {
      fontWeight: type.fontWeight.medium,
    },
  },
  PricingList: {
    [MD_MEDIA_QUERY]: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      flexDirection: 'row',

      '& $Accordion': {
        flexBasis: '47%',
        maxWidth: '47%',
        flexGrow: 1,

        '&:nth-child(odd)': {
          paddingRight: '1.5%',
        },
        '&:nth-child(even)': {
          paddingLeft: '1.5%',
        },
      },
    },
  },
  SeeAllLink: {
    fontSize: 18,
    fontWeight: 700,
  },
}));
